export const CUSTOM_HTML = `
...on customHtml_Entry {
  id
  typeHandle
  anchor
  outputToHead
  html
}
`

